import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "@/components/lingo/DashboardLayout";
import AICoachFloating from "@/components/lingo/AICoachFloating";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Video, Plus, Calendar } from "lucide-react";
import { toast } from "sonner";

export default function Classrooms() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [creating, setCreating] = useState(false);
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");

  const load = async () => {
    const r = await api.get("/classrooms");
    setItems(r.data);
  };
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!title) return;
    try {
      await api.post("/classrooms", { title, scheduled_at: date || null });
      toast.success("Class created");
      setTitle(""); setDate(""); setCreating(false); load();
    } catch (e) { toast.error("Failed"); }
  };

  const canCreate = ["TEACHER", "ADMIN", "STUDENT"].includes(user?.role);

  return (
    <DashboardLayout title="Live Classes">
      <div className="flex items-center justify-between mb-6">
        <div className="text-sm text-slate-500">Embedded video — no Zoom required.</div>
        {canCreate && (
          <button onClick={() => setCreating(true)} data-testid="cls-create-btn" className="px-4 py-2 rounded-full bg-[#F77F00] text-white text-sm inline-flex items-center gap-2">
            <Plus className="w-4 h-4" /> New class
          </button>
        )}
      </div>
      {creating && (
        <div className="bg-white border border-slate-200 rounded-2xl p-5 mb-6">
          <div className="grid sm:grid-cols-3 gap-3">
            <input data-testid="cls-title-input" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Class title" className="bg-[#F6F8FB]/50 border border-slate-200 rounded-xl px-4 py-2.5" />
            <input data-testid="cls-date-input" type="datetime-local" value={date} onChange={(e) => setDate(e.target.value)} className="bg-[#F6F8FB]/50 border border-slate-200 rounded-xl px-4 py-2.5" />
            <button onClick={create} data-testid="cls-create-submit" className="bg-[#F77F00] text-white rounded-xl">Create</button>
          </div>
        </div>
      )}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((c) => (
          <Link key={c.id} to={`/app/classrooms/${c.id}`} data-testid={`cls-${c.id}`} className="bg-white border border-slate-200 rounded-2xl p-6 hover:bg-slate-50 hover:-translate-y-0.5 transition-all">
            <Video className="w-6 h-6 text-[#F77F00] mb-3" />
            <div className="font-display text-lg">{c.title}</div>
            <div className="text-xs text-slate-400 mt-1 flex items-center gap-2"><Calendar className="w-3 h-3" /> {c.scheduled_at?.slice(0, 16).replace("T", " ") || "Anytime"}</div>
            <div className="text-xs text-slate-400 mt-2">Host: {c.host_name || "—"}</div>
          </Link>
        ))}
        {!items.length && <div className="col-span-3 text-center py-16 text-slate-400">No live classes yet. Book a free trial or create one.</div>}
      </div>
      <AICoachFloating />
    </DashboardLayout>
  );
}
